import { return_01, return_02, return_03, return_04, return_05 } from "../../_components/Imagepath";

  
  export default {
    SalesData: [
    
        {
            "id": 1,
            "product": "Lenovo 3rd Generation",
            "image": return_01,
            "code": "PPT001",
            "category": "Laptop",
            "price": "$8253.00",
            "quantitySold": 50,
            "quantityAvailable": 100,
            "date": "20 Aug 2023"
          },
          {
            "id": 2,
            "product": "Nike Jordan",
            "image": return_02,
            "code": "PPT005",
            "category": "Shoe",
            "price": "$1360.00",
            "quantitySold": 70,
            "quantityAvailable": 140,
            "date": "23 Aug 2023"
          },
          {
            "id": 3,
            "product": "Apple Series 5 Watch",
            "image": return_03,
            "code": "PPT010",
            "category": "Accessories",
            "price": "$724.00",
            "quantitySold": 30,
            "quantityAvailable": 200,
            "date": "25 Aug 2023"
          },
          {
            "id": 4,
            "product": "Amazon Echo Dot",
            "image": return_04,
            "code": "PPT104",
            "category": "Electronics",
            "price": "$210.00",
            "quantitySold": 20,
            "quantityAvailable": 250,
            "date": "27 Aug 2022"
          },
          {
            "id": 5,
            "product": "Lobar Handy",
            "image": return_05,
            "code": "PPT050",
            "category": "Furniture",
            "price": "$155.00",
            "quantitySold": 40,
            "quantityAvailable": 300,
            "date": "30 Aug 2022"
          }

    ],
  };
  